import { css } from "@compiled/react";

import { ConfluenceOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation, {
    ReturnToProduct
} from "@/components/signup/site-activation";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    Headings,
    ReturnToProductSubheading,
    ReturnToProductText,
    WelcomeBackHeading,
    WelcomeBackText
} from "../../../components";

export const CurrentProductUser = () => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    return (
        <ConfluenceOverlayTemplate size="sm">
            <div css={containerCss}>
                {team26VisualUpdates ? (
                    <Headings
                        main={<WelcomeBackText />}
                        sub={<ReturnToProductText />}
                    />
                ) : (
                    <>
                        <WelcomeBackHeading />
                        <ReturnToProductSubheading />
                    </>
                )}
                <SiteActivation
                    CurrentProductUser={<ReturnToProduct />}
                    useContactExpandCohortLogic={true}
                />
            </div>
        </ConfluenceOverlayTemplate>
    );
};

const containerCss = css({
    display: "grid",
    gap: "10px"
});
